import axios from 'axios'
import { addDoc, collection, deleteDoc, doc, endAt, getDoc, getDocs, limit, orderBy, query, startAt, Timestamp, where } from 'firebase/firestore';
import { db } from '../utils/firebase';
import { startOfDay, endOfDay } from 'date-fns';

export const formatDate = (dateInput) => {
    let date;
    
    // Handle different input types
    if (dateInput instanceof Date) {
      date = dateInput;
    } else if (typeof dateInput === 'number') {
      date = new Date(dateInput * 1000); // Convert seconds to milliseconds
    } else if (dateInput && typeof dateInput === 'object' && 'seconds' in dateInput) {
      date = new Date(dateInput.seconds * 1000); // Convert Firestore timestamp
    } else {
      return 'Invalid date';
    }
  
    // Pad numbers to ensure two digits
    const pad = (num) => num.toString().padStart(2, '0');
    
    const day = pad(date.getDate());
    const month = pad(date.getMonth() + 1); // Months are 0-indexed
    const year = date.getFullYear();
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());
    
    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  };

export const getLotteryData = async (startDate, endDate) => {
    if (startDate && endDate) {
        const registrationsRef = collection(db, 'lottery');
        const q = query(
            registrationsRef,
            where('createdAt', '>=', Timestamp.fromDate(startOfDay(startDate))),
            where('createdAt', '<=', Timestamp.fromDate(endOfDay(endDate)))
        );

        const querySnapshot = await getDocs(q);
        const fetchedData = [];

        querySnapshot.forEach((doc) => {
            const data = doc.data();

            fetchedData.push({
                data: {
                    ...data,
                    createdAt: {
                        seconds: data.createdAt.seconds,
                        nanoseconds: data.createdAt.nanoseconds
                    },
                    date: formatDate(data.createdAt)
                },
                documentName: doc.id,
                date: new Date(data.createdAt.seconds * 1000).toLocaleString('tr-TR')
            });
        });


        return { data: fetchedData, status: 200 };
    }
    else {
        const q = query(collection(db, "lottery"), orderBy("createdAt", 'desc'));
        const querySnapshot = await getDocs(q);
        let data = []
        querySnapshot.forEach((doc) => {
            data.push({ data: doc.data(), documentName: doc.id })
        });


        return { data: data, status: 200 };
    }
    
}


